const laneConfig = {
  widthFirstColumn: 220,
  widthDayBreaker: 15,
  minHeight: 20,
  doSnap: true,
  snapToMinutes: 60, // 15, 30, 60
  smallestSnapWidth: 19,
};

export default laneConfig;
